module.exports = __webpack_public_path__ + "img/esign-wechat-tag.0342db87.svg";